<template>
  <div>
    <div class="BackupPlanName-title">
      <Breadcrumb>
        <BreadcrumbItem
          to="/resourceConfigurEationManagement/aws/backup/plan"
          >{{ $t("RAM.AWS.Backup.Plan.title") }}</BreadcrumbItem
        >
        <BreadcrumbItem>{{ this.$route.query.backupPlanName }}</BreadcrumbItem>
      </Breadcrumb>
      <div class="date">{{ $t("RAM.AWS.Backup.Plan.backupPlanRule") }}</div>
      <Table
        :no-data-text="$t('common.noData')"
        :columns="columns"
        :data="tableDate"
        style="width: 100.1%"
      >
      </Table>
      <div class="date">{{ $t("RAM.AWS.Backup.Plan.resourceAllocation") }}</div>
      <Table
        :no-data-text="$t('common.noData')"
        :columns="dateColumns"
        :data="tableDates"
        style="width: 100.1%"
      >
      </Table>
    </div>
  </div>
</template>

<script>
var tableDateVue = {};
export default {
  name: "BackupPlanName",
  data() {
    return {
      current: 1,
      dataTotal: 0,
      val: "",
      columns: [
        {
          title: this.$t("RAM.AWS.Backup.Plan.ruleName"),
          key: "ruleName",
        },
        {
          title: this.$t("RAM.AWS.Backup.Plan.targetBackupVaultName"),
          key: "targetBackupVaultName",
        },
        {
          title: this.$t("RAM.AWS.Backup.Plan.destinationBackupVaultArn"),
          key: "destinationBackupVaultArn",
        },
      ],
      dateColumns: [
        {
          title: this.$t("RAM.AWS.Backup.Plan.selectionName"),
          key: "selectionName",
        },
        {
          title: this.$t("RAM.AWS.Backup.Plan.iamRoleArn"),
          key: "iamRoleArn",
        },
        {
          title: this.$t("RAM.AWS.Backup.Plan.creationDate"),
          key: "creationDate",
        },
      ],
      tableDate: [],
      tableDates: [],
    };
  },
  beforeCreate: function () {
    tableDateVue = this;
  },
  mounted: function () {
    tableDateVue.getElasticResourceData();
  },
  methods: {
    // 显示数据
    /****************************************************/
    getElasticResourceData: function () {
      //列表分页
      this.$api.resourceManagement
        .getBackupPlanDetails({ id: this.$route.query.id })
        .then((res) => {
          this.tableDate = res.data.resourceAwsBackupPlanRuleDTOS;
          this.tableDates =
            res.data.resourceAwsBackupPlanResourceAssignmentDTOS;
        });
    },
  },
};
</script>

<style scoped>
.BackupPlanName-title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 15px 4px;
  font-weight: 600;
}
.date {
  margin-top: 20px;
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/aws/backup/plan/BackupPlanName.vue